import React, { useEffect, useState } from 'react'
import { Alert, Button } from 'react-bootstrap';
import { trackPromise } from 'react-promise-tracker';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenSquare } from '@fortawesome/free-solid-svg-icons';
import DesenvolvedoresService from '../../../services/desenvolvedorService';
import DommusTabelaPaginada from '../../DommusTabelaPaginada';
import DommusModal from '../../DommusModal';
import ConfigUsuarioAPI from '../ConfigUsuarioAPI';

export default function UsuariosDesenvolvedor() {
    const [rows, setRows] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [tipoModalAcessos, setTipoModalAcessos] = useState('Criar');

    const [usuario, setUsuario] = useState([]);


    function buscarUsuariosAcesso() {
        trackPromise(DesenvolvedoresService.usuariosComAcesso())
            .then((response) => {
                const linhas = response.data.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                {item.id}
                            </td>
                            <td>
                                {item.nome}

                            </td>
                            <td>
                                <Button variant='primary' onClick={(e) => { abrirModalEditarUsuario(item) }}><FontAwesomeIcon icon={faPenSquare} /></Button>
                            </td>
                        </tr>
                    )
                }
                );
                setRows(linhas);
            }).catch(error => {
                Swal.fire('Ooops...', 'Houve um ao buscar a lista de desenvolvedores.', 'error')
            })
    }

    function abrirModalEditarUsuario(item) {
        setModalOpen(true)
        setTipoModalAcessos('Editar')
        setUsuario(item)
    }

    function fecharModalEditar() {
        setModalOpen(false)
    }

    const thead = (
        <tr style={{ justifyContent: "center" }}>
            <th >ID</th>
            <th >Nome</th>
            <th className="text-center" style={{ width: '8%' }} >Editar</th>
        </tr>
    );

    useEffect(() => {
        buscarUsuariosAcesso()
    }, [])

    return (
        <>
            {rows.length > 0 ? (
                <DommusTabelaPaginada
                    linhasCabecalho={thead}
                    optionsTabela={{}}
                    linhasCorpo={rows}
                />
            ) : (
                <Alert variant="warning">Nenhuma tarefa a ser exibida.</Alert>
            )}

            <DommusModal
                open={isModalOpen}
                close={(e) => setModalOpen(false)}
                titulo={"Usuário"}
                size={"lg"}
                centered
                content={<ConfigUsuarioAPI usuarioAcesso={usuario} tipo={tipoModalAcessos} fecharModal={fecharModalEditar}/>}
            >
            </DommusModal>
        </>
    )
}
